import React from 'react';
import { CheckIcon } from 'lucide-react';
import { volumes, volumeIncludes, coverage } from '../data/volumes';
const stats = [{
  value: '+280',
  label: 'Páginas'
}, {
  value: '+150',
  label: 'Ejercicios'
}, {
  value: '12',
  label: 'Volúmenes'
}, {
  value: 'Todos',
  label: 'Los Niveles'
}];
export function SystemOverview() {
  return <section className="w-full bg-court-950 py-20 text-white" aria-labelledby="system-title" data-id="element-207" data-mp="1ho469b8nca4v">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-208" data-mp="tyi90tbu44zi">
        <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-ball" data-id="element-209" data-mp="pwwpip4sosgc">
          🏆 El sistema más completo para entrenadores de tenis
        </p>
        <div className="mt-6 grid gap-10 lg:grid-cols-[1fr_1fr] lg:items-end" data-id="element-210" data-mp="13u374gds8l3z">
          <div data-id="element-211" data-mp="yvi7oj6cu5gl">
            <h2 id="system-title" className="font-display text-4xl font-black leading-[1.05] tracking-tight sm:text-5xl" data-id="element-212" data-mp="yz61zkjmivwd">
              TENIS 360™
              <span className="mt-2 block text-ball" data-id="element-213" data-mp="2ac044j9yc838">12 Volúmenes + 6 Bonos</span>
            </h2>
          </div>
          <p className="text-lg leading-relaxed text-court-600" data-id="element-214" data-mp="238gvzgunu4uf">
            Más de 280 páginas de sesiones listas para usar, ejercicios profesionales, progresiones
            por nivel, herramientas de planificación y gestión de alumnos —{' '}
            <span className="font-semibold text-white" data-id="element-215" data-mp="2i3wsdsipqctz">todo ya hecho para ti.</span>
          </p>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-px overflow-hidden rounded-2xl bg-court-800 sm:grid-cols-4" data-id="element-216" data-mp="1kgxu5dcdgwtz">
          {stats.map(stat => <div key={stat.label} className="bg-court-900 px-4 py-6 text-center" data-id="element-217" data-mp="1pcmwtpjoutui">
              <p className="font-display text-3xl font-black text-ball" data-id="element-218" data-mp="1ubzelvvpdaq8">{stat.value}</p>
              <p className="mt-1 text-[10px] uppercase tracking-[0.16em] text-court-600" data-id="element-219" data-mp="1z63nwlsfxuuh">
                {stat.label}
              </p>
            </div>)}
        </div>

        <div className="mt-16" data-id="element-220" data-mp="16n6r8nt5cb78">
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-court-600" data-id="element-221" data-mp="16mdglbr2h1jt">
            Cobertura total · Todos los niveles y edades
          </p>
          <ul className="mt-5 flex flex-wrap gap-2" data-id="element-222" data-mp="tnxl4du8i7iz">
            {coverage.map(item => <li key={item} className="rounded-full border border-court-800 bg-court-900 px-4 py-2 text-sm text-white" data-id="element-223" data-mp="18ck02efy8x9o">
                {item}
              </li>)}
          </ul>
        </div>

        <div className="mt-20" data-id="element-224" data-mp="apuqnjix3ids">
          <h3 className="font-display text-2xl font-black tracking-tight sm:text-3xl" data-id="element-225" data-mp="aqmoz23wfu7r">
            Los 12 Volúmenes Completos
          </h3>
          <ol className="mt-8 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-226" data-mp="pof25nlz46is">
            {volumes.map(volume => <li key={volume.number} className="flex h-full flex-col rounded-2xl border border-court-800 bg-court-900 p-6 transition-[border-color,transform] duration-200 ease-smooth hover:-translate-y-0.5 hover:border-ball/50" data-id="element-227" data-mp="kqdjv4wdgb8d">
                <div className="flex items-center gap-2.5" data-id="element-228" data-mp="23ldt6ssfnx92">
                  <span className="h-2.5 w-2.5 rounded-full" style={{
                backgroundColor: volume.dot
              }} aria-hidden="true" data-id="element-229" data-mp="28m1uq8eafwhj" />
                  <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-court-600" data-id="element-230" data-mp="1ymu7mthr4nh8">
                    Volumen {volume.number}
                  </span>
                </div>
                <h4 className="mt-3 font-display text-lg font-extrabold leading-snug tracking-tight" data-id="element-231" data-mp="2rcsz0vjf4wp2">
                  {volume.title}
                </h4>
                <p className="mt-2 text-sm leading-relaxed text-court-600" data-id="element-232" data-mp="2dis8gp2mefzs">{volume.subtitle}</p>
                <p className="mt-auto pt-5 text-xs leading-relaxed text-ball/80" data-id="element-233" data-mp="2hkdhu0fy4c58">
                  {volume.tags.join(' · ')}
                </p>
              </li>)}
          </ol>
        </div>

        <div className="mt-16 rounded-3xl border border-court-800 bg-court-900 p-8 sm:p-10" data-id="element-234" data-mp="3a4vi0djj8p2h">
          <h3 className="font-display text-xl font-black uppercase tracking-tight sm:text-2xl" data-id="element-235" data-mp="1mccuztv83fts">
            Lo que incluye cada volumen
          </h3>
          <ul className="mt-6 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-236" data-mp="1cfi0rn5zg1lb">
            {volumeIncludes.map(item => <li key={item} className="flex items-start gap-3 text-sm text-white" data-id="element-237" data-mp="18fzqdlbsf8wq">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-ball" strokeWidth={3} aria-hidden="true" data-id="element-238" data-mp="25572k2qio5nz" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}